import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Pencil, Trash2, CheckCircle2, RotateCcw } from "lucide-react";
import { useAuthedApi, errMsg, formatINR, imgUrl } from "../../lib/api";

export default function MyListings() {
  const api = useAuthedApi();
  const [items, setItems] = useState(null);
  const load = () => { api("get", "/listings/mine").then(setItems); };
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const act = async (fn, msg) => { try { await fn(); toast.success(msg); load(); } catch (e) { toast.error(errMsg(e)); } };

  if (!items) return <p className="text-gray-500">Loading...</p>;
  if (!items.length) return <div className="lux-card p-16 text-center text-gray-400" data-testid="no-listings">You haven't listed any cars yet. <Link to="/sell" className="text-[#E5C158]">Sell your car</Link></div>;
  return (
    <div className="space-y-4" data-testid="my-listings">
      {items.map((c) => (
        <div key={c.id} className="lux-card p-4 flex flex-col sm:flex-row gap-5 sm:items-center" data-testid={`my-listing-${c.id}`}>
          <img src={imgUrl(c.images[0])} alt="" className="w-full sm:w-40 aspect-[16/10] object-cover rounded-xl" />
          <div className="flex-1">
            <Link to={`/cars/${c.id}`} className="font-semibold hover:text-[#E5C158]">{c.year} {c.brand} {c.model} {c.variant}</Link>
            <p className="font-display text-2xl gold-text">{formatINR(c.price)}</p>
            <p className="text-xs text-gray-400">{c.city}, {c.state} · {c.seller_type === "dealer" ? "Dealer store" : "Private owner"} · <span className={c.status === "sold" ? "text-red-400" : "text-emerald-400"}>{c.status}</span></p>
          </div>
          <div className="flex gap-2 flex-wrap">
            <Link to={`/sell?edit=${c.id}`} className="btn-outline !px-4 !py-2 text-xs" data-testid={`edit-listing-${c.id}`}><Pencil className="w-3.5 h-3.5" />Edit</Link>
            <button className="btn-outline !px-4 !py-2 text-xs" data-testid={`toggle-sold-${c.id}`} onClick={() => act(() => api("patch", `/listings/${c.id}/status?status=${c.status === "sold" ? "active" : "sold"}`), "Status updated")}>
              {c.status === "sold" ? <><RotateCcw className="w-3.5 h-3.5" />Relist</> : <><CheckCircle2 className="w-3.5 h-3.5" />Mark sold</>}
            </button>
            <button className="btn-outline !px-4 !py-2 text-xs !text-red-400 !border-red-500/40" data-testid={`delete-listing-${c.id}`} onClick={() => window.confirm("Delete this listing?") && act(() => api("delete", `/listings/${c.id}`), "Listing deleted")}><Trash2 className="w-3.5 h-3.5" />Delete</button>
          </div>
        </div>
      ))}
    </div>
  );
}
